<div class="daily-punches-wrapper">
  @if (busyService.loading$ | async) {
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  } @else {
    <punches-nav></punches-nav>

    <div class="header">
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

      <button class="nav-btn" type="button" (click)="previousDay()">← {{ previousDayDate }}</button>

      <div class="calendar-wrapper">
        <button class="selected-date" type="button" (click)="toggleCalendar()">
          <img src="/calendar.png" alt="Calendar" class="calendar-icon" />
          <span class="date-text">{{ selectedDate | date: 'MMM d, yyyy' }}</span>
        </button>

        <div *ngIf="calendarOpen" class="calendar-overlay">
          <div class="calendar-header">
            <button class="arrow-btn prev-month" type="button" (click)="prevMonth()">
              <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                <polyline points="15 18 9 12 15 6" fill="none" stroke="currentColor" stroke-width="2" />
              </svg>
            </button>

            <span class="month-label">{{ months[selectedMonth] }}</span>

            <button class="arrow-btn next-month" type="button" (click)="nextMonth()">
              <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                <polyline points="9 6 15 12 9 18" fill="none" stroke="currentColor" stroke-width="2" />
              </svg>
            </button>

            <select [(ngModel)]="selectedYear" (change)="onYearChange($event)">
              <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
          </div>

          <div class="calendar-body">
            <div class="weekdays">
              <div
                *ngFor="let day of ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']"
                class="weekday"
              >
                {{ day }}
              </div>
            </div>

            <div class="days">
              <div
                *ngFor="let day of calendarDays"
                (click)="selectDate(day)"
                [class.today]="isToday(day)"
                [class.selected]="isSelected(day)"
              >
                {{ day.getDate() }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="nav-btn" type="button" (click)="nextDay()">{{ nextDayDate }} →</button>
    </div>
  }

  <div class="filters-container" *ngIf="!(busyService.loading$ | async)">
    <div class="filters-row">
      <label class="filter-field">
        <span>Company</span>

        <select [(ngModel)]="selectedCompanyId" (ngModelChange)="onCompanyChange($event)">
          <option [ngValue]="null">All companies</option>

          <option
            *ngFor="let company of filterService.filterValues?.companies"
            [ngValue]="company.id"
          >
            {{ company.name }}
          </option>
        </select>
      </label>

      <label class="filter-field">
        <span>Department</span>

        <select [(ngModel)]="selectedDepartmentId" (ngModelChange)="onDepartmentChange($event)">
          <option [ngValue]="null">All departments</option>

          <option
            *ngFor="let department of filterService.filterValues?.departments"
            [ngValue]="department.id"
          >
            {{ department.code }} - {{ department.name }}
          </option>
        </select>
      </label>

      <label class="filter-field search-field">
        <span>Search</span>

        <input
          type="text"
          [(ngModel)]="filters.searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
          placeholder="Search employee name"
        />
      </label>

      <div class="filter-actions">
        <button
          class="nav-btn clear-filters-btn"
          type="button"
          (click)="clearFilters()"
          [disabled]="!hasActiveFilters"
        >
          Clear Filters
        </button>
      </div>
    </div>
  </div>

  <div class="color-key" *ngIf="!(busyService.loading$ | async)">
    <div class="key-item">
      <div class="key-block scheduled"></div>
      Scheduled
    </div>

    <div class="key-item">
      <div class="key-block offtime-approved"></div>
      Off Time Approved
    </div>

    <div class="key-item">
      <div class="key-block offtime-pending"></div>
      Off Time Pending
    </div>

    <div class="key-item">
      <div class="key-block active"></div>
      Missing Punch
    </div>

    <div class="key-item">
      <div class="key-block inactive"></div>
      Completed
    </div>
  </div>

  <div class="timeline-container" *ngIf="!(busyService.loading$ | async)">
    <div class="timeline-right" #timelineRight>
      <div class="hour-stripes" aria-hidden="true">
        <div *ngFor="let hour of [].constructor(24); let index = index" [class.even]="index % 2 === 0"></div>
      </div>

      <div class="timeline-overlay" aria-hidden="true">
        <div
          *ngIf="isSelectedDateToday()"
          class="current-time-line"
          [style.left.%]="currentTimePercent"
        ></div>
      </div>

      <div class="timeline-header">
        <div class="employee-header"></div>

        <div class="hour-numbers" aria-hidden="true">
          <div *ngFor="let hour of [].constructor(24); let index = index">
            {{ (index < 10 ? '0' + index : index) + ':00' }}
          </div>
        </div>
      </div>

      <div class="timeline-body">
        <div *ngFor="let employee of punches" class="timeline-row">
          <div class="employee-cell">
            {{ employee.lastName }}, {{ employee.firstName }}
            <span class="employee-id">({{ employee.employeeNumber || employee.id }})</span>
          </div>

          <div class="timeline-cell">
            <div class="employee-schedules" *ngIf="employee.schedules.length">
              <div
                *ngFor="let schedule of employee.schedules"
                class="schedule-block"
                [style.left.%]="getScheduleLeftPercent(schedule)"
                [style.width.%]="getScheduleWidthPercent(schedule)"
              >
                <span *ngIf="canShowScheduleLabel(schedule)" class="time-label">
                  {{ formatScheduleRange(schedule) }}
                </span>

                <div class="tooltip">
                  {{ formatScheduleRange(schedule) }}
                </div>
              </div>
            </div>

            <div class="employee-offtimes" *ngIf="employee.offTimes.length">
              <div
                *ngFor="let offTime of employee.offTimes"
                class="offtime-block"
                [ngClass]="getOffTimeClass(offTime)"
                [style.left.%]="getOffTimeLeftPercent(offTime)"
                [style.width.%]="getOffTimeWidthPercent(offTime)"
              >
                <span *ngIf="canShowOffTimeLabel(offTime)" class="time-label">
                  {{ formatOffTimeRange(offTime) }}
                </span>

                <div class="tooltip">
                  {{ formatOffTimeRange(offTime) }}
                </div>
              </div>
            </div>

            <div class="employee-punches">
              <div
                *ngFor="let punch of employee.punches"
                class="punch-block"
                [class.active]="punch.isActive"
                [style.left.%]="getBlockLeftPercent(punch)"
                [style.width.%]="getBlockWidthPercent(punch)"
              >
                <span *ngIf="canShowPunchLabel(punch)" class="time-label">
                  {{ formatRange(punch) }}
                </span>

                <div class="tooltip">
                  {{ formatRange(punch) }}
                </div>
              </div>
            </div>

            <div class="schedule-label-overlay" *ngIf="employee.schedules.length" aria-hidden="true">
              <div
                *ngFor="let schedule of employee.schedules"
                class="schedule-label-slot"
                [style.left.%]="getScheduleLeftPercent(schedule)"
                [style.width.%]="getScheduleWidthPercent(schedule)"
              >
                <span *ngIf="canShowScheduleLabel(schedule)" class="time-label">
                  {{ formatScheduleRange(schedule) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!punches.length && !errorMessage" class="no-data">
          No punches, schedules, or off time found for this day.
        </div>
      </div>
    </div>
  </div>
</div>